/** @jsx h */
import { h, Component } from 'preact'
import TagLine from '../TagLine'
import FlagIcon from '../icons/FlagIcon'

import { initSingleLocationMap } from '../../../modules/mapbox'
import { organizationAvatar, mapBoxStyleLight } from './CollaborationCard'

class CollaborationFront extends Component {
  componentDidMount () {
    initSingleLocationMap(
      $('.Mapbox-map--collaboratorFrontCard'),
      $('.Mapbox-map--collaboratorFrontCard').attr('id'),
      false
    )
  }

  render () {
    const { collaborator, activity, flipCard, claim } = this.props

    const titleClass = collaborator.avatarUrl
      ? 'collaborationAvatar'
      : 'collaborationFrontCard'
    const sectionMargin = collaborator.avatarUrl
      ? 'u-marginTop64'
      : 'u-marginTop16'
    const coordinates = claim.location
      ? `[${claim.location.longitude}, ${claim.location.latitude}]`
      : 'unknown'
    // const locationName = claim.location ? claim.location.displayName : 'Unknown';

    return (
      <div class='ClaimCard ClaimCard--initiatives'>
        <div class='ClaimCard-header ClaimCard-header--collaboration ClaimCard-header--collaborationFrontCard'>
          <div class='Mapbox ClaimCard-map--collaboration'>
            <div
              class='Mapbox-map Mapbox-map--nonInteractive Mapbox-map--collaboratorFrontCard'
              data-coordinates={coordinates}
              data-styleid={mapBoxStyleLight}
              id={`Mapbox-map--collaboratorFront-${claim.id}`}
            />
            <div class='Mapbox-overlay' />
          </div>
          <div class='ClaimCard-logo ClaimCard-logo--collaborationFrontCard ClaimCard-logo--gradient'>
            <TagLine />
          </div>
          <div
            class={`ClaimCard-title--collaboration ClaimCard-title--${titleClass}`}
          >
            Handshake
          </div>
          {organizationAvatar(collaborator)}
        </div>
        <div class='ClaimCard-section'>
          <div>
            <p class={`Text-bodySerif ${sectionMargin}`}>Organisation</p>
            <p class='ClaimCard-name--collaboration'>{collaborator.name}</p>
          </div>
          <p class='Text-bodySerif u-marginTop8'>{activity}</p>
          {claim.location
            ? <p class='ClaimCard-locationText Text-bodySansSmall u-marginTop8'><FlagIcon /> {claim.location.displayName}</p>
            : ''}
        </div>

        <div class='ClaimCard-footer ClaimCard-footer--initiatives'>
          <button class='ClaimCard-action' onClick={flipCard} type='button'>
            See the proof
          </button>
        </div>
      </div>
    )
  }
}

export default CollaborationFront
